var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-item",on:{"mousedown":_vm.mousedown,"mouseup":_vm.mouseup}},[(_vm.closeable)?_c('i',{staticClass:"el-icon-error drag-item-delete",on:{"click":_vm.deleteItem}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }